import { ArrowRight, Check } from "lucide-react";
import { scrollToSection } from "./Navbar";
import { Reveal } from "./Reveal";
import { Star } from "./Logo";
import { useLang } from "@/i18n/LanguageContext";

const IMG = "https://static.prod-images.emergentagent.com/jobs/78bcda24-ecc7-4097-99a8-74d5dca5b1b3/images/c8585d1701c3bb33ee950a5fed68e15af7e26578f85cba11c5b81d264c599954.jpeg";

export default function Phygital() {
  const { t } = useLang();
  const p = t.phygital;

  return (
    <section id="phygital" className="mx-auto max-w-7xl px-5 sm:px-8 py-24 sm:py-36" data-testid="phygital-section">
      <div className="grid grid-cols-1 gap-14 lg:grid-cols-2 lg:gap-20 lg:items-center">
        <Reveal>
          <p className="flex items-center gap-2 text-xs uppercase font-medium" style={{ color: "var(--camel)", letterSpacing: "0.16em" }}>
            <Star size={11} /> {p.kicker}
          </p>
          <h2 className="mt-5 font-serif-display text-4xl sm:text-5xl font-semibold leading-tight" data-testid="phygital-title">
            {p.title}
          </h2>
          <p className="mt-5 max-w-md text-base md:text-lg leading-relaxed" style={{ color: "var(--muted-warm)" }}>
            {p.sub}
          </p>
          <ul className="mt-9 space-y-4">
            {p.questions.map((q, i) => (
              <li key={i} className="flex items-start gap-3 text-sm sm:text-base" data-testid={`phygital-question-${i + 1}`}>
                <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full" style={{ background: "var(--rose-soft)" }}>
                  <Check size={13} style={{ color: "var(--camel)" }} />
                </span>
                <span className="font-medium">{q}</span>
              </li>
            ))}
          </ul>
          <button
            onClick={() => scrollToSection("casestudy")}
            data-testid="phygital-cta"
            className="pill-btn mt-10 inline-flex items-center gap-2 rounded-full px-7 py-3.5 text-sm font-medium text-white"
            style={{ background: "var(--camel)" }}
          >
            {p.cta} <ArrowRight size={15} />
          </button>
        </Reveal>
        <Reveal delay={0.15}>
          <div className="overflow-hidden rounded-3xl border" style={{ borderColor: "var(--line)" }}>
            <img src={IMG} alt={p.title} className="h-72 sm:h-96 w-full object-cover transition-transform duration-700 hover:scale-105" loading="lazy" />
          </div>
        </Reveal>
      </div>

      <div className="mt-16 grid grid-cols-1 gap-5 md:grid-cols-3">
        {p.benefits.map((b, i) => (
          <Reveal
            key={i}
            delay={i * 0.1}
            className="rounded-3xl border p-8 transition-shadow duration-500 hover:shadow-[0_24px_48px_-24px_rgba(198,156,109,0.4)]"
            style={{ background: "var(--surface-secondary)", borderColor: "var(--line)" }}
            data-testid={`phygital-benefit-${i + 1}`}
          >
            <span className="font-serif-display text-3xl font-semibold" style={{ color: "var(--gold)" }}>✦</span>
            <h3 className="mt-4 font-serif-display text-2xl font-semibold">{b.title}</h3>
            <p className="mt-2.5 text-sm leading-relaxed" style={{ color: "var(--muted-warm)" }}>{b.text}</p>
          </Reveal>
        ))}
      </div>
    </section>
  );
}
